<template>
  <common-dialog ref="dialog" width="800px" title="明细字段" @closed="onClosed">
    <template slot="form">
      <el-table :data="data.Settings" border style="width: 100%" height="600px">
        <el-table-column prop="FormKey" label="字段名称"></el-table-column>
        <el-table-column prop="ShowField" label="是否显示" width="80">
          <template slot-scope="{row}">
            <el-checkbox v-model="row.IsShow" @change="onChange($event,row)"></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="close">关闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import dialogMixin from "@/mixins/dialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [dialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        DocType: "",
        Settings: [],
      },
      api: require('@/api/sy/docSetting').default,
    };
  },
  methods: {
    getData(data) {
      this.data.DocType = data.DocType;
      var userid = this.$store.state.user.id;
      this.api.list({ DocType: data.DocType }).then(res => {
        if (res.Code == 0) {
          this.data.Settings = res.Data.map(x => { return { ...x, T: null } });
          if (this.data.Settings.length == 0) {
            var fields = require(`@/data/${data.Url}/fields.json`);
            this.data.Settings = fields.map(x => { return { ...x, UserId: userid } })
          }
        } else {
          this.$message.error("获取明细字段失败");
        }
      })
    },
    onChange(value, row) {
      if (row.T == null) row.T = 1;
    },
    save() {
      var data = {
        DocType: this.data.DocType,
        Settings: this.data.Settings.filter(x => x.T != null)
      }
      this.api.save(data).then(res => {
        if (res.Code == 0) {
          this.$message.success("保存成功");
          // var showFields = this.data.Settings.filter(x => x.IsShow == true);
          this.$emit('close-saved');
          this.close(true);
        } else this.$message.error(res.Msg);
      })
    },
    onClosed() {
      this.data.Settings = [];
    },
  },
};
</script>